import { render, staticRenderFns } from "./DashboardComponents.vue?vue&type=template&id=43ebbbf7&"
import script from "./DashboardComponents.vue?vue&type=script&lang=js&"
export * from "./DashboardComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports